import React, { useState, useReducer, useEffect } from "react";
import AsyncJsonLoader from "../auth/AsyncJsonLoader";
import CommentList from "./CommentList";
import { useLocation, useNavigate, Link, Navigate } from "react-router-dom";
import $ from "jquery";

import "../css/comment-list.css";

import getAllCssRules from '../../js/utils/getAllCssRules';
import { saveAs } from '../../js/utils/FileSaver';
import CommentType from "../../js/models/CommentType";


function SearchFormField({ label, name, setter, defaultValue, value, type, options }) {

  return (
    <div className="form-group">
      <div className="row">
      <label className="col-md-2 control-label" htmlFor={name}>{label}</label>
      <div className="col-md-10">
      {(function(){
        switch (type) {
          case "select": 
            return (
              <select 
                className="form-control"
                name={name}
                id={name}
                onChange={e => setter(e.target.value)}
                defaultValue={defaultValue}
              >
              {
                options.map(
                  (op) => {
                    return <option key={op.value} value={op.value}>{op.text}</option>
                  }
                )
              }
              </select>
            )
          default      :
            return (
              <input 
                type={type?type:"text"}
                className="form-control" 
                name={name} 
                id={name} 
                onChange={e => setter(e.target.value)} 
                defaultValue={defaultValue}
              />
            )
        }
      }).call()}
      </div>
      </div>
    </div>
  )
}

function searchFormReducer(data, action) {
  data[action.key] = action.value
  return data
}

function SearchForm({ onSubmit, fields, controls }) {

  const [data, dispatch] = useReducer(
    searchFormReducer,
    fields,
    (fields) => {
      return fields.reduce(
        (data, field) => {
          data[field.name] = field.defaultValue; 
          return data
        }, {}
      )

    }
  )

  function handleSubmit(event){
    event.preventDefault();
    onSubmit(data)
  }

  return (
    <div className="comments-search-form container">
    <form onSubmit={handleSubmit}>
{/*      <div className="row"><h4 className="col-md-12">Поиск</h4></div>*/}
      {
        fields.map((field) => {
          switch (field.type) {
            case "header": 
              return <div key={field.name} className="form-group">
                <div className="row">
                  <div className="col-md-12"><h4>{field.label}</h4></div>
                </div>
              </div>
            default      : 
              return <SearchFormField 
                key={field.name} { ...field }
                value={data[field.name]} 
                setter={
                  (value)=>{
                    dispatch({ key: field.name, value })
                    field.onChange && field.onChange(value)
                  }
                } /> 
          }
        })
      }
      <div className="form-group right">
        <div className="row"> {
            controls? controls :
            <div className="col-md-10"></div>
          }
          <div className="col-md-2">
            <input type="submit" className="btn btn-primary pull-right form-control" value="Найти" />
          </div>
        </div>
      </div>
    </form>
    </div>
  )
}

function Pagination({page, count, limit, getPath}) {
  const pages = limit > 0 ? Math.ceil(count/limit): 1

  if (page && pages > 0) {
    if (page < 1) 
      return <Navigate to={getPath(1)}/>
    else if (page > pages)
      return <Navigate to={getPath(pages)} />
  }

  if (pages > 1) {
    return (
      <div style={{"marginTop": "10px", "textAlign": "center"}}>
        { Array.from({length: pages}, (_, i)=> {
          return <Link 
            key={i} 
            to={getPath(i+1)}
            style={{
              "fontSize": "18px",
              "padding": "0 3px",
            }}
          >{i+1}</Link>
        }) }    
      </div>
    )
  } else return null
}

/*
  Загружает список комментариев и затем рендерит CommentList с ним
*/
export default function CommentsLoader({commentId}) {
  const location = useLocation();
  const search = location.search;
  console.log(search);
  const navigate = useNavigate();

  const query = new URLSearchParams(useLocation().search);
  console.log(query);
  const [commentTypes] = useState(()=>Object.entries(CommentType))

  const fields = [
    {label: "Поиск"  , name: "search" , type: "header"},
    {
      label: "Тип комментария:", name: "type"  , defaultValue: query.get('type'), 
      type :"select",
      options: [{
        text: "Все",
        value: ""
      },...commentTypes.map(([key, commentType]) => {
        return {
          text : commentType.fullName,
          value: `${key},${commentType.name}`
        }
      })]
    },
    {label: "Текст:"          , name: "text"  , defaultValue: query.get('text')  },
    {label: "Автор:"          , name: "author", defaultValue: query.get('author')},
    {label: "Начальная дата:" , name: "start" , defaultValue: query.get('start') , type:"date"},
    {label: "Конечная дата:"  , name: "finish", defaultValue: query.get('finish'), type:"date"},

  ]
  function pathByPage(page, limit){
    const tmpPage = query.get("page")
    const tmpLimit = query.get("limit")
    if (page) {
      query.set("page", page)
    }
    if (limit) {
      query.set("limit", limit)
    }
    const search = `${query}`
    if (tmpPage) {
      query.set("page", tmpPage)
    }
    if (tmpLimit) {
      query.set("limit", tmpLimit)
    }
    return `/comments?${search}`;
  }

  const paginator = 
    function(data){
      console.log(data);
      return (
        <Pagination 
          page={query.get('page')} 
          count={data.count} 
          limit={query.get('limit')} 
          getPath={pathByPage}
        />
      )
    }

  if (!(Number(query.get("page")) > 0)) {
    return <Navigate to={pathByPage(1)} />
  }

  if (!(Number(query.get("limit")) > 0)) {
    return <Navigate to={pathByPage(null, 5)} />
  }

  function saveListAsHtml(){
    /* const $ = window.jQuery */

    const root = $('<div>').append($(".comment-list").clone())
    $("*", root).each(function(){
      if (this.tagName.toLowerCase() === 'script') return
      $(this).css(getAllCssRules($(this), $))
      $(this).css("cursor", "")
    })

    const divs = $('a',root).map(function(){
      const div = $('<div>')
      div.attr('style', $(this).attr('style'))
      div.html($(this).html())
      return div[0].outerHTML
    }).toArray().join('')

    $('.comment-list', root).html(divs)

    const bodyCss = getAllCssRules($('body'), $)
    bodyCss['max-width'] = "1170px";
    bodyCss['margin']    = "0 auto";

    $(root).css(bodyCss)

    const content = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8" />
          <title>Document</title>
      </head>
          ${$(root)[0].outerHTML}
      </html>  
    `

    const blob = new Blob([ content ], {type: "text/plain;charset=utf-8"})
    saveAs(blob, `Список вопросов.html`);
  }
  console.log(search);
  return (
    <React.Fragment>
      {/* <SearchForm fields={fields} onSubmit={(data)=>{
          fields.forEach(
            (field) => {
              const name = field.name
              let value = data[name]
              /*Костыль. убрать!
              if (field.type === "select") {
                const options = field.options
                if (!options.some(op => op.value === value)) {
                  if (options.length > 0) {
                    value = options[0].value
                  } else value = ""
                }
              }
              /*конец костыля
              if (value) {
                query.set(name, value)
              } else query.delete(name)
            } 
          )
          const path = `/comments?${query}`;
          navigate(path);
        }}
        controls={
          <React.Fragment>
            <div className='col-md-7'></div>
            <div className='col-md-3'>
              <input 
                className='btn btn-default form-control' 
                type='button' 
                style={{width: "100%"}} 
                value='Сохранить список'
                onClick={()=>saveListAsHtml()}
              />
            </div>
          </React.Fragment>
        }
      /> */}
      <div className="container">
      <AsyncJsonLoader path={`/api/comments${search}`} render={(data)=>{
        return (
          <React.Fragment>
            {paginator(data)}
            <CommentList comments = {data.comments || []} count={data.count}/>
            {paginator(data)}
          </React.Fragment>
        )
      }} />
      </div>
    </React.Fragment>
  )
}